export default __webpack_public_path__ + "6120bc0e6b73f09edbee0ed845a48ed7.svg";